// Дзеркало Prisma enum ApprovalStep. Крок маршруту погодження (D25): кафедра → факультет → навчальний відділ → затвердження → публікація.
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const ApprovalStep = {
    DEPARTMENT: 'DEPARTMENT',
    FACULTY: 'FACULTY',
    ACADEMIC_OFFICE: 'ACADEMIC_OFFICE',
    APPROVAL: 'APPROVAL',
    PUBLICATION: 'PUBLICATION',
};
/** Значення в порядку оголошення в схемі. */
export const APPROVAL_STEP_VALUES = ['DEPARTMENT', 'FACULTY', 'ACADEMIC_OFFICE', 'APPROVAL', 'PUBLICATION'];
export const APPROVAL_STEP_LABELS = {
    DEPARTMENT: 'Кафедра',
    FACULTY: 'Факультет',
    ACADEMIC_OFFICE: 'Навчальний відділ',
    APPROVAL: 'Затвердження',
    PUBLICATION: 'Публікація',
};
//# sourceMappingURL=approval-step.js.map